<div class="TN">
    <div class="TN__header">
        <div class="TN__heading">
            Choose your unique domain name
        </div>
        <div class="TN__subHeading">
            This is where you will access your new account. Make sure <br/> to bookmark it once you're inside
        </div>
    </div>
    <form class="TN__content" @submit.prevent="onSubmit">
        <input-container :dirtyForm="$v.$dirty || !isDomainAvailable">
            <div class="TN__teamName-wrapper">
                <div class="TN__teamName">
                    <text-field class="input-field"
                        :error="hasError('subDomain') || !isDomainAvailable"
                        v-model="subDomain"
                        @blur="checkDomainAvailability"
                        @enter="checkDomainAvailability">
                    </text-field>
                    <text-field class="input-field" v-model="domainName" disabled></text-field>
                </div>
                <progress-spinner class="TN__name-spinner" v-if="checking"></progress-spinner>
                <mom-icon class="TN__name-available" width="24" height="24"
                    svgIcon="checked-circle" v-else-if="checkDone && isDomainAvailable"></mom-icon>
                <mom-icon class="TN__name-unavailable" width="24" height="24"
                    svgIcon="cross-circle" v-else-if="checkDone && !isDomainAvailable"></mom-icon>
            </div>
            <linear-progress class="TN__progress" v-if="loading"></linear-progress>

            <mom-error v-if="!$v.subDomain.required">Domain name is required.</mom-error>
            <mom-error v-else-if="!$v.subDomain.isValid">Please enter a valid domain name.</mom-error>
            <mom-error v-else-if="!isDomainAvailable">Domain name already exists.</mom-error>
        </input-container>
        <div class="TN__proceed">
            <mom-button type="submit" variant="raised" :disabled="loading || checking || !isDomainAvailable">Next</mom-button>
        </div>
    </form>
</div>